export function createFeatureServingClient(transport) {
    return {
        /**
         * List every tenant's online features, as a staleness limit and one instant
         *
         * Requires scope: feature-serving:platform:read
         */
        listPlatformMlFeatures(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/ml-features",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/features
         *
         * Requires scope: feature-serving:define
         */
        registerFeature(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/features`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/features/{featureId}/entities/{entityKey}
         *
         * Requires scope: feature-serving:read
         */
        getOnlineFeature(tenantId, featureId, entityKey, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/features/${encodeURIComponent(featureId)}/entities/${encodeURIComponent(entityKey)}`,
                options,
            });
        },
        /**
         * PUT /internal/v1/tenants/{tenantId}/features/{featureId}/entities/{entityKey}
         *
         * Requires scope: feature-serving:write
         */
        putOnlineFeatureValue(tenantId, featureId, entityKey, body, options) {
            return transport.request({
                method: "PUT",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/features/${encodeURIComponent(featureId)}/entities/${encodeURIComponent(entityKey)}`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=feature-serving.js.map